"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "giffoni-valle-piana": {
    "433801cb": [{
      "hkey": "63d67177",
      "slug": "giffoni-valle-piana",
      "name": "Giffoni Valle Piana",
      "primary": true,
      "skipSearch": false
    }],
    "chiaravallisi": [{
      "hkey": "63d67177",
      "slug": "giffoni-valle-piana",
      "name": "Giffoni Valle Piana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b9b715d4": [{
      "hkey": "63d67177",
      "slug": "giffoni-valle-piana",
      "name": "Giffoni Valle Piana",
      "primary": true,
      "skipSearch": false
    }],
    "chieve": [{
      "hkey": "63d67177",
      "slug": "giffoni-valle-piana",
      "name": "Giffoni Valle Piana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a2b56814": [{
      "hkey": "63d67177",
      "slug": "giffoni-valle-piana",
      "name": "Giffoni Valle Piana",
      "primary": true,
      "skipSearch": false
    }],
    "curticelle": [{
      "hkey": "63d67177",
      "slug": "giffoni-valle-piana",
      "name": "Giffoni Valle Piana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7e77598c": [{
      "hkey": "63d67177",
      "slug": "giffoni-valle-piana",
      "name": "Giffoni Valle Piana",
      "primary": true,
      "skipSearch": false
    }],
    "gaia": [{
      "hkey": "63d67177",
      "slug": "giffoni-valle-piana",
      "name": "Giffoni Valle Piana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "865bff8e": [{
      "hkey": "63d67177",
      "slug": "giffoni-valle-piana",
      "name": "Giffoni Valle Piana",
      "primary": true,
      "skipSearch": false
    }],
    "pozzarolo": [{
      "hkey": "63d67177",
      "slug": "giffoni-valle-piana",
      "name": "Giffoni Valle Piana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "64094115": [{
      "hkey": "1721d9d2",
      "slug": "san-giovanni-santa-caterina",
      "name": "San Giovanni-Santa Caterina",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "1721d9d2",
      "slug": "san-giovanni-santa-caterina",
      "name": "San Giovanni-Santa Caterina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "29d7a7f1": [{
      "hkey": "1721d9d2",
      "slug": "san-giovanni-santa-caterina",
      "name": "San Giovanni-Santa Caterina",
      "primary": true,
      "skipSearch": false
    }],
    "santa-caterina": [{
      "hkey": "1721d9d2",
      "slug": "san-giovanni-santa-caterina",
      "name": "San Giovanni-Santa Caterina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "giffoni-valle-piana"
    }],
    "d4351ead": [{
      "hkey": "63d67177",
      "slug": "giffoni-valle-piana",
      "name": "Giffoni Valle Piana",
      "primary": true,
      "skipSearch": false
    }],
    "vassi": [{
      "hkey": "63d67177",
      "slug": "giffoni-valle-piana",
      "name": "Giffoni Valle Piana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;